import React, {useCallback} from 'react';
import {IReduxRootState} from '../../../../../@interfaces';
import {useDispatch, useSelector} from 'react-redux';
import RenderIf from '../../../../RenderIf/RenderIf';
import {toggleNotificationsList} from '../../../../../_redux/notifications/actions';
import classnames from '../../../../../helpers/classnames';

export default function NotificationsToggler() {
    const dispatch = useDispatch();
    const {unreadNumber, listDisplayed} = useSelector((state: IReduxRootState) => {
        return state.notifications;
    });

    const toggle = useCallback(() => {
        dispatch(toggleNotificationsList());
    }, [dispatch]);

    return <div>
        <button type="button" className="btn notifications__header-toggler header__menu-item" onClick={toggle}>
            <i className={classnames('fa-bell', {
                'far': !listDisplayed,
                'fas': listDisplayed,
                'animation-bell-ring': unreadNumber > 0,
            })}/>

            <RenderIf expression={unreadNumber}>
                <span className="badge bg-danger rounded-pill">
                    {unreadNumber > 99 ? '99+' : unreadNumber}
                </span>
            </RenderIf>
        </button>
    </div>;
}
